import Api from '@/api/api';
import ApiMapzUrl from "@/api/apiMapz";
import baseApi from '@/api/apiFileUrl';
import apiCommonUrl from '@/api/apiCommonUrl';

export default {
    getVehicle() {
        return Api.get(`/api/Vehicle/GetVehicles`);
        // return Api.get(`Vendor/Vehicle/GetVehiclesByVendorAndFacility?Vendorid=${vendorID}&facilityID=${faceID}`)
    },  
    //TODO Delete below method  
    getVehicleAlongWithBillingInfo(vendorID, faceID) {
        return Api.get(`/ETMSAgr/Common/GetVehiclesByVendorAndFacility?vendorID=${vendorID}&facilityID=${faceID}`);
    },
    async getVehicleById(id) {
        await Api.get(`/api/Vehicle/GetVehicle/${id}`);
        // return Api.get('Vendor/Vehicle/GetVehicle/' + id)
    },
    addVehicle(data) {
        return Api.post(`/api/Vehicle/AddVehicle`, data);
        // return Api.post('Vendor/Vehicle/AddVehicle', data)
    },
    updateVehicle(id, data) {
        return Api.put(`/api/Vehicle/UpdateVehicle/${id}`, data);
        // return Api.put('Vendor/Vehicle/UpdateVehicle/' + id, data)
    },
    deleteVehicle(id) {
        return Api.delete(`/api/Vehicle/DeleteVehicle/${id}`)
        // return Api.delete('Vendor/Vehicle/DeleteVehicle/' + id)
    },


    //TODO Delete all below APIS
    getVehicleFuelTypes () {
        return Api.get(`/vendor/Vehicle/GetVehicleFuelTypes`);
    },
    getVehiclesByFacility (facility) {
        return Api.get(`/vehicle/GetVehiclesByFacility?facilityID=${facility}`);
    },
    //File Upload API

    getVehicleFile() {
        return Api.get('Org/api/FileUpload')
    },
    getVehicleFileByid(channelKey,id) {
        return baseApi.get(`/fileupload/API/fileupload/GetFileHistories?channelKey=${channelKey}&referenceID=${id}&referenceType=Vehicle&tag=`)
        // return Api.get(`/api/Vehicle/GetUploadedVehicleFile?referenceID=${id}&referenceType=Vehicle`)
        // return Api.get('Org/api/FileUpload/GetUploadedFile?referenceId=' + id + '&referenceType=Vehicle')

    },
    getVehicleModels(filters) {
        return Api.get(`SaasAdmin/api/TenantConfig/VehicleModels?tenantID=${filters.tenantID}&facilityID=${filters.facilityID}`)
    },
    uploadFile(data) {
        return baseApi.post(`/fileupload/API/fileupload/BulkUploadFile?channelKey=${data.channelKey}&referenceID=${data.id}&referenceType=Vehicle&tags=`,data.data)
        // return Api.post('/api/Vehicle/UploadVehicleFile?ReferenceId=' + data.id + '&ReferenceType=Vehicle', data.data)
        // return Api.post('Org/api/FileUpload/UploadFile?ReferenceId=' + data.id + '&ReferenceType=Vehicle', data.data)
    },
    // downloadFile(url) {
    //     return Api.get(url)
    // },
    deleteFile(data) {
        return baseApi.delete(`/fileupload//API/fileupload/DeleteUploadedFile/${data.channelKey}/${data.id}`)
        // return Api.delete('Org/api/FileUpload?id=' + id)
        // return Api.delete('/api/Vehicle/DeleteUploadedVehicle/' + id);

    },
    viewFile(channelKey,id) {
        return baseApi.get(`/fileupload/API/fileupload/GetFileUploadedUrl/${channelKey}/${id}/view`)
    },
    downloadFile(channelKey,id) {
        return baseApi.get(`/fileupload/API/fileupload/GetFileUploadedUrl/${channelKey}/${id}/download`)
    },
    getColumn() {
        return Api.get('Org/api/Settings/ExplicitColumns?actor=Vehicle')
    },
    vehicleUploadTemplate(formData, config){
        return Api.post(`/api/Vehicle/UploadTemplate/UploadTemplate`, formData, config)
    },
    vehicleDownloadTemplate() {
        return Api.get('/api/Vehicle/DownloadVehicleTemplate/DownloadVehicleTemplate', {
            responseType: 'blob',
        })
    },
    getVehicleLocationByLatLong(lat, lon) {
        return ApiMapzUrl.get(`/nominatim/reverse?lat=${lat}&lon=${lon}&format=json`);
    },
    getCommonVehicleModels(filters) {
        return apiCommonUrl.get(`SaasAdmin/api/TenantConfig/VehicleModels?tenantID=${filters.tenantID}&facilityID=${filters.facilityID}`)
    },
  
}